import { createSlice } from '@reduxjs/toolkit';
import { StudyYearCategoryCompaniesState } from '@/types/study-year-category-company';
import { studyYearCategoryCompanies } from './thunks';

const initialState: StudyYearCategoryCompaniesState = {
  isLoading: false,
  error: null,
  currentStudyYearCategoryCompany: null,
  isUpdating: false,
  isLoadingParent: false,
  isLoadingHistory: false,
  parentCompany: null,
  companyHistory: null,
};

export const studyYearCategoryCompaniesSlice = createSlice({
  name: 'studyYearCategoryCompanies',
  initialState,
  reducers: {
    clearError: state => {
      state.error = null;
    },
    clearCurrentStudyYearCategoryCompany: state => {
      state.currentStudyYearCategoryCompany = null;
    },
    clearParentCompany: state => {
      state.parentCompany = null;
    },
    clearCompanyHistory: state => {
      state.companyHistory = null;
    },
    clearAll: state => {
      state.currentStudyYearCategoryCompany = null;
      state.parentCompany = null;
      state.companyHistory = null;
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      // Get Study Year Category Company
      .addCase(studyYearCategoryCompanies.getStudyYearCategoryCompany.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        studyYearCategoryCompanies.getStudyYearCategoryCompany.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.error = null;
          state.currentStudyYearCategoryCompany = action.payload;
        }
      )
      .addCase(studyYearCategoryCompanies.getStudyYearCategoryCompany.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
        state.currentStudyYearCategoryCompany = null;
      })
      // Update Study Year Category Company
      .addCase(studyYearCategoryCompanies.updateStudyYearCategoryCompany.pending, state => {
        state.isUpdating = true;
        state.error = null;
      })
      .addCase(
        studyYearCategoryCompanies.updateStudyYearCategoryCompany.fulfilled,
        (state, action) => {
          state.isUpdating = false;
          state.error = null;
          state.currentStudyYearCategoryCompany = action.payload;
        }
      )
      .addCase(
        studyYearCategoryCompanies.updateStudyYearCategoryCompany.rejected,
        (state, action) => {
          state.isUpdating = false;
          state.error = action.payload as string;
        }
      )
      // Get Study Year Category Company Parent
      .addCase(studyYearCategoryCompanies.getStudyYearCategoryCompanyParent.pending, state => {
        state.isLoadingParent = true;
        state.error = null;
      })
      .addCase(
        studyYearCategoryCompanies.getStudyYearCategoryCompanyParent.fulfilled,
        (state, action) => {
          state.isLoadingParent = false;
          state.error = null;
          state.parentCompany = action.payload;
        }
      )
      .addCase(
        studyYearCategoryCompanies.getStudyYearCategoryCompanyParent.rejected,
        (state, action) => {
          state.isLoadingParent = false;
          state.error = action.payload as string;
          state.parentCompany = null;
        }
      )
      // Get Study Year Category Company History
      .addCase(studyYearCategoryCompanies.getStudyYearCategoryCompanyHistory.pending, state => {
        state.isLoadingHistory = true;
        state.error = null;
      })
      .addCase(
        studyYearCategoryCompanies.getStudyYearCategoryCompanyHistory.fulfilled,
        (state, action) => {
          state.isLoadingHistory = false;
          state.error = null;
          state.companyHistory = action.payload;
        }
      )
      .addCase(
        studyYearCategoryCompanies.getStudyYearCategoryCompanyHistory.rejected,
        (state, action) => {
          state.isLoadingHistory = false;
          state.error = action.payload as string;
          state.companyHistory = null;
        }
      );
  },
});

export const {
  clearError,
  clearCurrentStudyYearCategoryCompany,
  clearParentCompany,
  clearCompanyHistory,
  clearAll,
} = studyYearCategoryCompaniesSlice.actions;

export const studyYearCategoryCompaniesReducer = studyYearCategoryCompaniesSlice.reducer;
